// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.passwordStrengthChecker_strengthIndicatorContainer__Cw7bE {
    width: 100%;
    display: grid;
    grid-template-columns: 1fr 1fr 1fr 1fr;
    gap: 4px;
}

.passwordStrengthChecker_indicator__yrp1A {
    height: 4px;
    background-color: #ccc;
}
`, "",{"version":3,"sources":["webpack://./src/_components/passwordStrengthChecker/passwordStrengthChecker.module.css"],"names":[],"mappings":"AAAA;IACI,WAAW;IACX,aAAa;IACb,sCAAsC;IACtC,QAAQ;AACZ;;AAEA;IACI,WAAW;IACX,sBAAsB;AAC1B","sourcesContent":[".strengthIndicatorContainer {\n    width: 100%;\n    display: grid;\n    grid-template-columns: 1fr 1fr 1fr 1fr;\n    gap: 4px;\n}\n\n.indicator {\n    height: 4px;\n    background-color: #ccc;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"strengthIndicatorContainer": `passwordStrengthChecker_strengthIndicatorContainer__Cw7bE`,
	"indicator": `passwordStrengthChecker_indicator__yrp1A`
};
export default ___CSS_LOADER_EXPORT___;
